<template>
  <div class="v-input v-text-field">
    <div :class="classes" style="position: relative; width: 100%">
      <div class="input-group__input" :style="`height: ${heightEditor};`">
        <label :class="classesLabel" style="position: absolute; left:0px; top: -16px;">{{label}} </label>
        <!-- <div> -->
        <div id="htmlValueEditor"></div>
      <!-- </div> -->
      </div>
      <div v-if="hint" class="input-group__details"><div class="input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message">{{hint}}</div></div>
</div>
  <v-btn small icon @click="showPopup">
      <i style="width: 16px; height: 16px;display: inline-block; background-size: contain;" class="v-icon theme--light icon-macro"></i>
    </v-btn>  
</div>
</template>

<script>
  import {createEditor} from 'vueditor'
  import lang from '../vueditor/lang.ru.js'
  import macro from '../vueditor/macro.vue'

  import 'vueditor/dist/style/vueditor.min.css'

  const plugins = [
    {
      name: 'macro',
      element: {
        type: 'button',
        lang: {
          title: 'Макрос'
        },
        className: 'icon-macro'
      },
      component: macro
    }
  ]

  export default {
    name: 'v-macro-field',
    props: {
      label: null,
      value: {
        type: String,
        default: ''
      },
      hint: null,
      heightEditor: {
        type: String,
        default: '36px'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      macro: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        editor: null,
        isDirty: false,
        focused: false
      }
    },
    mounted () {
      if (!this.editor) {
        this.editor = this.genEditor()
      }
      this.setValue(this.value)
      this.setReadonly(this.readonly)
    },
    watch: {
      value: function (newValue) {
        this.setValue(newValue)
      },
      readonly: function (newValue) {
        this.setReadonly(newValue)
      }
    },
    computed: {
      classes () {
        return {
          // '.pa-0': this.solo,
          'input-group--solo': this.solo,
          'elevation-0': this.flat,
          'input-group': true,
          'input-group--text-field': true,
          'primary--text': this.focused,
          'input-group--focused': this.focused,
          'input-group--dirty': this.isDirty,
          'input-group--tab-focused': true
        }
      },
      classesLabel () {
        return {
          'caption': true,
          'v-label': true,
          'theme--light': !this.focused
        }
      }
    },
    methods: {
      setValue (value) {
        // console.log('setValue', value)
        this.editor && value && (this.editor.value = value)
      },
      setReadonly (value) {
        this.editor && (this.editor.readonly = value)
      },
      genEditor () {
        let config = {
          toolbar: [
            'fullscreen', 'sourceCode', 'undo', 'redo', '|',
            // 'element',
            'fontName', 'fontSize',
            'foreColor', 'backColor', 'divider', 'bold', 'italic', 'underline', 'strikeThrough',
            'link', 'unLink',
             // 'divider', 'subscript', 'superscript',
            'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull',
            '|', 'indent', 'outdent', 'insertOrderedList', 'insertUnorderedList', '|',
            // 'picture', 'table', '|',
            // 'code',
            'removeFormat',
            '|', 'macro'
            // , 'markdown'
          ],
          shortbar: [],
          fontName: [
            { val: 'Arial' },
            { val: 'Times New Roman' },
            { val: 'Courier New' }
          ],
          headStyle: `
            <style>
              body {font-family: Arial; margin: 0; padding-top: 8px; padding-bottom: 8px; line-height: 20px;}
              pre {margin: 0; padding: 0.5rem;}
            </style>`,
          lang: lang
        }
        if (this.macro) {
          config.plugins = plugins
        }
        let inst = createEditor('#htmlValueEditor', config)
        inst.$on('input', () => {
          this.$emit('input', inst.getContent())
        })
        inst.$on('focus', () => {
          this.focused = true
        })
        inst.$on('blur', () => {
          this.focused = false
        })
        inst.value = null
        return inst
      },
      showPopup (e) {
        let obj = e.target
        let action = 'macro'
        if (this.editor) {
          // this.editor.$store.dispatch('showPopup', { name: action, params: null })
          this.editor.$store.dispatch('updatePopupDisplay', {name: action, display: true})
          this.editor.$store.dispatch('updateRect', {
            left: obj.offsetLeft,
            top: obj.offsetTop,
            width: obj.offsetWidth,
            height: obj.offsetHeight + parseInt(window.getComputedStyle(obj).marginBottom)
          })
        }
      }
    }
  }
</script>
<style type="text/css">
  .vueditor {
    min-height: 38px;
    min-width: 150px;
    border-top:  none;
    border-left:  none;
    border-right:  none;
  }
  .input-group--focused .vueditor {
    border-bottom-color: currentColor;
    border-bottom-width:  2px;
  }
  .vueditor .ve-toolbar {
    border-bottom-width: 0px;
  }

</style>



// WEBPACK FOOTER //
// MacroField.vue?60412bd5